(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["door-nav"] && !Shopify.designMode) return;
  try {
    
  /* L241 pinned bar: on once the tile grid has scrolled off the top (lego script,
     IntersectionObserver). Theme adaptations: (1) the site header is sticky, so the
     bar pins UNDER it (--l241-pin-top) and "off the top" means past the header's
     bottom edge (rootMargin); (2) idempotent + re-run on shopify:section:load, and
     torn down on :unload, so the theme editor can re-render the section. */
  (function () {
    function headerH() {
      var h = document.querySelector('.shopify-section.section-header');
      if (!h) return 0;
      var cs = window.getComputedStyle(h);
      return (cs.position === 'sticky' || cs.position === 'fixed') ? Math.round(h.getBoundingClientRect().height) : 0;
    }
    function init(root) {
      var nav = root.querySelector('#l241-nav'), bar = root.querySelector('#l241-pinbar');
      if (!nav || !bar || !('IntersectionObserver' in window)) return;
      if (root.__l241io) root.__l241io.disconnect();
      var top = headerH();
      bar.style.setProperty('--l241-pin-top', top + 'px');
      var io = new IntersectionObserver(function (e) {
        var r = e[0];
        bar.classList.toggle('is-on', !r.isIntersecting && r.boundingClientRect.bottom < top);
      }, { threshold: 0, rootMargin: (-top) + 'px 0px 0px 0px' });
      io.observe(nav);
      root.__l241io = io;
    }
    function all() {
      document.querySelectorAll('.l244-nav').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(all, 200); });
    document.addEventListener('shopify:section:load', function (ev) {
      var root = ev.target && ev.target.querySelector && ev.target.querySelector('.l244-nav');
      if (root) init(root);
    });
    document.addEventListener('shopify:section:unload', function (ev) {
      var root = ev.target && ev.target.querySelector && ev.target.querySelector('.l244-nav');
      if (root && root.__l241io) { root.__l241io.disconnect(); root.__l241io = null; }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-doors"] && !Shopify.designMode) return;
  try {
    
/* L34's dialog contract, scoped to this section's own root and id. Idempotent
   and re-wired on shopify:section:load, per the theme's hard rules. */
(function () {
  function wire(root) {
    if (!root || root.dataset.wired === '1') return;
    root.dataset.wired = '1';
    var trigger = root.querySelector('[data-lp-module="traceability-modal"]');
    var scrim = root.querySelector('.om-modal-scrim');
    if (!trigger || !scrim) return;
    var closer = scrim.querySelector('.om-modal-close');
    var lastScroll = '';

    function open() {
      scrim.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      lastScroll = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (closer) closer.focus();
    }
    function close() {
      scrim.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = lastScroll;
      trigger.focus();
    }
    trigger.addEventListener('click', open);
    if (closer) closer.addEventListener('click', close);
    scrim.addEventListener('click', function (e) { if (e.target === scrim) close(); });
    // focus trap: Tab cycles inside the panel while it is open
    scrim.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = scrim.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !scrim.hidden) close();
    });
  }
  function init(scope) { (scope || document).querySelectorAll('.lego-L52-v6').forEach(wire); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-buy-box"] && !Shopify.designMode) return;
  try {
    
  // ==========================================================================
  // Custom buy-box selector wiring (2026-06-18). Drives our own size + plan
  // control: on selection it sets the Dawn form's variant id (.product-variant-id),
  // the Skio selling_plan (.lp-selling-plan, '' for one-time), and rewrites the
  // in-button price (.product-form__submit--current-price) for size x plan. Scoped
  // per .lp-buybox instance (both slot-main + slot-closing run independently) and
  // idempotent + re-bound on shopify:section:load so the theme editor can't break it.
  // ==========================================================================
  (function () {
    function initBuyBox(root) {
      if (!root || root.dataset.lpWired === '1') return;
      root.dataset.lpWired = '1';

      var sizes = root.querySelectorAll('.lp-buybox__sizes .lp-buybox__size');
      var plans = root.querySelectorAll('.lp-buybox__plans .lp-buybox__plan');
      var spInput = root.querySelector('.lp-selling-plan');
      var idInput = root.querySelector('.product-variant-id');
      var atcPrice = root.querySelector('.product-form__submit--current-price');
      var subPrice = root.querySelector('.js-sub-price');
      var oncePrice = root.querySelector('.js-once-price');
      var perday = root.querySelector('.js-perday');

      function sel(list) {
        for (var i = 0; i < list.length; i++) { if (list[i].classList.contains('is-sel')) return list[i]; }
        return list[0] || null;
      }
      function refresh() {
        var s = sel(sizes), p = sel(plans);
        if (!s || !p) return;
        var isSub = p.getAttribute('data-plan') === 'sub';
        if (idInput) idInput.value = s.getAttribute('data-variant');
        if (spInput) spInput.value = isSub ? p.getAttribute('data-selling-plan') : '';
        if (subPrice) subPrice.textContent = s.getAttribute('data-sub');
        if (oncePrice) oncePrice.textContent = s.getAttribute('data-once');
        if (perday) perday.textContent = s.getAttribute('data-perday');
        if (atcPrice) atcPrice.textContent = isSub ? s.getAttribute('data-sub') : s.getAttribute('data-once');
      }
      function choose(group, btn) {
        for (var i = 0; i < group.length; i++) {
          group[i].classList.remove('is-sel');
          group[i].setAttribute('aria-checked', 'false');
        }
        btn.classList.add('is-sel');
        btn.setAttribute('aria-checked', 'true');
        refresh();
      }
      sizes.forEach(function (b) { b.addEventListener('click', function () { choose(sizes, b); }); });
      plans.forEach(function (b) { b.addEventListener('click', function () { choose(plans, b); }); });
      refresh(); // sync defaults (first size + Subscribe) into the form + price on load
    }
    function initAll() {
      document.querySelectorAll('.lp-buybox').forEach(initBuyBox);
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }
    // Theme editor: re-wire the reloaded section instance.
    document.addEventListener('shopify:section:load', function (e) {
      var scope = e.target && e.target.querySelectorAll ? e.target : document;
      scope.querySelectorAll('.lp-buybox').forEach(function (el) { el.dataset.lpWired = ''; initBuyBox(el); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-buy-box"] && !Shopify.designMode) return;
  try {
    
/*
  L46 V6's own script, with the comp's hardcoded PRICING object replaced by a
  real read. THE RAIL IS UNCHANGED: the subscription price, the percentage and
  the dollar savings never exist in first-paint HTML — they are written in by
  the same named sync(), called at wiring time (Subscribe is checked, D-054) and
  on every change.

  Theme-editor lifecycle: wiring is idempotent (dataset.wired) and re-runs on
  shopify:section:load, per the theme's hard rules.
*/
(function () {
  // wi-2026-launch-pdp-drawer-fix: a successful add must open/refresh the cart
  // drawer. Nothing ever subscribed to the 'pdp:added' DOM event this file
  // dispatches below, so the drawer never opened. This reuses the exact
  // pattern assets/door-body.js uses (the doors have always worked): publish
  // the theme's cartUpdate pub/sub (cart-drawer.js's <cart-drawer-items>
  // listens for it and reloads+opens the parent <cart-drawer>), and fall back
  // to calling the element directly when pub/sub isn't on the page.
  function openDrawer() {
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-buy-box' });
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.reload === 'function') drawer.reload().then(function () { drawer.open(); });
  }

  function money(cents, sample) {
    // Format from the page's own money string so the currency and the decimal
    // convention come from Shopify, never from a hardcoded '$'.
    var m = String(sample || '').match(/^([^\d]*)([\d.,]+)([^\d]*)$/);
    var body = (cents / 100).toFixed(2);
    if (!m) return body;
    if (m[2].indexOf(',') > -1 && m[2].indexOf('.') === -1) body = body.replace('.', ',');
    return m[1] + body + m[3];
  }

  function wire(root) {
    if (!root || root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    var cfgNode = root.querySelector('[data-pdp-pricing]');
    if (!cfgNode) return;
    var cfg;
    try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { return; }

    var slot       = root.querySelector('[data-sub-price-slot]');
    var saving     = root.querySelector('[data-sub-saving-slot]');
    var savingOrd  = root.querySelector('[data-sub-saving-order]');
    var savingYr   = root.querySelector('[data-sub-saving-year]');
    var oncePrice  = root.querySelector('[data-onetime-price]');
    var onceShip   = root.querySelector('[data-onetime-detail]');
    var perServing = root.querySelector('[data-per-serving]');
    var expressId  = root.querySelector('[data-express-variant]');
    var sub        = root.querySelector('[id^="l46-sub-"]');
    var addBtn     = root.querySelector('[data-atc="pdp_main"]');
    var subOpt     = root.querySelector('[data-lp-module="pdp-subscribe-toggle"]');

    // Filled AFTER load from Shopify's own product JSON. Until it resolves the
    // subscription nodes stay empty and hidden, which is the rail.
    var PLANS = {};

    // ---- B2B guard (wi-2026-0939) ------------------------------------------
    // Shopify refuses a selling plan on a B2B order ("Only one-time purchase is
    // available for B2B orders") and the add used to fail with nothing shown,
    // because Subscribe is preselected (D-054). window.__omIsB2B is set from
    // customer.b2b? in layout/theme.liquid, so it is true only for a company
    // buyer. Client-side on purpose: a normal shopper's server HTML is unchanged.
    // For a B2B buyer: One-time is checked, the Subscribe row (and the
    // subscription offer chips) are hidden, and PLANS is never filled, so
    // data-selling-plan stays empty and the sticky bar follows (it reads it).
    var B2B = window.__omIsB2B === true;
    var plansLoaded = false;   /* set once /products/<handle>.js answers (wi-2026-1186) */
    if (B2B) {
      if (subOpt) { subOpt.hidden = true; subOpt.dataset.sellingPlan = ''; }
      if (sub) { sub.checked = false; sub.disabled = true; }
      var onceRadio = root.querySelector('.om-opt--once input[name^="l46-purchase-"]');
      if (onceRadio) onceRadio.checked = true;
      var chips = root.querySelector('.reserved');
      if (chips) chips.hidden = true;
    }

    // ---- The add error line --------------------------------------------------
    // Created by script (so first-paint HTML is unchanged) and inserted BEFORE
    // any add, so the live region exists when text lands in it and is announced.
    var errLine = null;
    if (addBtn) {
      errLine = document.createElement('p');
      errLine.className = 'atc-error om-small';
      errLine.setAttribute('role', 'alert');
      errLine.setAttribute('data-lp', 'atc_error');
      addBtn.insertAdjacentElement('afterend', errLine);
    }
    function showError(msg) { if (errLine) errLine.textContent = msg || ''; }
    // /cart/add.js answers 422 with { message, description }; show Shopify's own words.
    function addResult(r) {
      if (r.ok) return r.json();
      return r.json().catch(function () { return {}; }).then(function (j) {
        var e = new Error('add failed');
        e.userMessage = (j && (j.description || j.message)) || 'Sorry, this could not be added to your cart. Please try again.';
        throw e;
      });
    }

    function currentVariant() {
      var r = root.querySelector('input[name^="l46-size-"]:checked');
      var id = r ? Number(r.value) : (cfg.variants[0] && cfg.variants[0].id);
      for (var i = 0; i < cfg.variants.length; i++) {
        if (cfg.variants[i].id === id) return cfg.variants[i];
      }
      return cfg.variants[0];
    }

    function fillPrice(node, plan, sample) {
      node.textContent = '';
      var p = document.createElement('span');
      p.textContent = money(plan.price, sample);
      var sep = document.createElement('span');
      sep.className = 'om-soft';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = ' · ';
      var pct = document.createElement('span');
      pct.className = 'sub-pct';
      pct.textContent = 'save ' + plan.pct + '%';
      node.appendChild(p); node.appendChild(sep); node.appendChild(pct);
    }

    function sync() {
      var vv = currentVariant();
      if (!vv) return;
      // wi-2026-1199: the selected size's pre-order ship date, if it has one.
      var shipNote = root.querySelector('[data-ships-note]'), shipMapEl = root.querySelector('[data-ships-map]');
      if (shipNote && shipMapEl) {
        var shipMap = {}; try { shipMap = JSON.parse(shipMapEl.textContent); } catch (e) {}
        var shipOn = shipMap[String(vv.id)];
        shipNote.hidden = !shipOn;
        var strong = shipNote.querySelector('strong'); if (strong) strong.textContent = shipOn ? ('This size ships ' + shipOn) : '';
      }
      if (oncePrice) oncePrice.textContent = vv.priceFormatted;
      if (onceShip)  onceShip.textContent  = vv.shipping;
      if (expressId) expressId.value = vv.id;
      if (perServing) {
        var n = Number(vv.servings) || 0;
        perServing.textContent = n > 0
          ? '≈ ' + money(Math.round(vv.price / n), vv.priceFormatted) + ' per serving'
          : '';
      }
      if (!slot || !sub) return;
      var plan = PLANS[vv.id];
      // wi-2026-1186: once the plans are known, a variant with none hides the
      // Subscribe row and falls back to One-time (never a checked, unpriced
      // Subscribe). B2B keeps its own hide above.
      if (plansLoaded && subOpt && !B2B) {
        subOpt.hidden = !plan;
        if (!plan && sub.checked) {
          sub.checked = false;
          var onceIn = root.querySelector('.om-opt--once input[name^="l46-purchase-"]');
          if (onceIn) onceIn.checked = true;
        }
      }
      var on = sub.checked && !!plan;
      if (on) { fillPrice(slot, plan, vv.priceFormatted); } else { slot.textContent = ''; }
      slot.hidden = !on;
      if (savingOrd) savingOrd.textContent = on ? ('Save ' + money(vv.price - plan.price, vv.priceFormatted) + ' on every order') : '';
      if (savingYr)  savingYr.textContent  = on ? (money((vv.price - plan.price) * 12, vv.priceFormatted).replace(/[.,]00(?=\D*$)/, '') + ' a year') : '';
      if (saving) saving.hidden = !on;
      if (subOpt) subOpt.dataset.sellingPlan = plan ? plan.id : '';
    }

    // ---- The one place any subscription number comes from -----------------
    fetch(cfg.handle ? ('/products/' + cfg.handle + '.js') : '', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants || B2B) return;   /* B2B: never offer a plan */
        plansLoaded = true;
        data.variants.forEach(function (dv) {
          var allocs = dv.selling_plan_allocations || [];
          if (!allocs.length) return;
          var best = allocs[0];
          allocs.forEach(function (a) { if (a.price < best.price) best = a; });
          PLANS[dv.id] = {
            id: best.selling_plan_id,
            price: best.price,
            pct: Math.round(((dv.price - best.price) / dv.price) * 100)
          };
        });
        sync();
      })
      .catch(function () { /* no subscription figures is the honest fallback */ });

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="l46-purchase-"], input[name^="l46-size-"]')) return;
      sync();
    });

    // ---- Per-size back panels (wi-2026-1194) --------------------------------
    // Only on products whose variants carry custom.variant_images (the marker
    // template is rendered only then). A size change re-renders THIS section for
    // that variant (Section Rendering API) and swaps in its gallery, so the
    // selected size's own back panel shows; the gallery script re-wires via its
    // init (window.omPdpGalleryInit). A failed fetch keeps the current gallery.
    if (root.querySelector('[data-l46-vargallery]')) {
      var galBox = root.querySelector('.gallery');
      var galSeq = 0;
      root.addEventListener('change', function (e) {
        if (!e.target.matches('input[name^="l46-size-"]') || !galBox) return;
        var vid = e.target.value, my = ++galSeq;
        var sid = (e.target.name || '').replace('l46-size-', '');
        var gBase = window.location.pathname.indexOf('/products/') > -1 ? window.location.pathname : ('/products/' + cfg.handle);   /* on a landing page the URL is not the product */
        fetch(gBase + '?variant=' + encodeURIComponent(vid) + '&section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html || my !== galSeq) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.lego-L46-v6 .gallery');
            if (!fresh) return;
            galBox.innerHTML = fresh.innerHTML;
            // Re-wire through the gallery's own init when it exposes one; else its
            // documented shopify:section:load hook (other listeners are idempotent).
            // The .pdp-gallery root is REPLACED by the innerHTML swap, so it arrives
            // unwired; Rewire (unwire + wire) is used when present to be safe.
            if (typeof window.omPdpGalleryRewire === 'function') window.omPdpGalleryRewire(galBox);
            else if (typeof window.omPdpGalleryInit === 'function') window.omPdpGalleryInit(galBox);
            else galBox.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
          })
          .catch(function () {});
      });
    }
    sync();   /* <- Subscribe is checked in the markup, so this reveals at load */

    // The gallery's own tab/thumb/arrow behaviour lives in assets/pdp-gallery.js
    // now (D-081, snippets/pdp-gallery.liquid) — nothing left to wire here.

    // ---- The add path, and the measurement contract it carries ------------
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var vv = currentVariant();
        if (!vv) return;
        var onSub = !B2B && sub && sub.checked && PLANS[vv.id];
        var item = { id: vv.id, quantity: 1 }, cartBefore = null;
        if (onSub) item.selling_plan = PLANS[vv.id].id;
        // row 18b: the Intelligems test groups ride every line item, from the
        // same source assets/product-form.js already reads.
        addBtn.setAttribute('aria-disabled', 'true');
        showError('');
        // row 18b: the test groups live on the CART, so they are read first.
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            cartBefore = c;
            var ig = c && c.attributes && c.attributes.igTestGroups;
            if (ig) item.properties = { _igTestGroups: ig };
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] })
            });
          })
          .then(addResult)
          // row 17: the SECOND call. /cart/add.js cannot write attributes.
          .then(function (added) {
            var bundleId = (subOpt && subOpt.dataset.bundleId) || '';
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                attributes: Object.assign({
                  bundle_id: bundleId,
                  // row 17b: enumerated values only. Carried VERBATIM.
                  bundle_src: onSub ? 'bundle_pdp_subscribe' : 'browse'
                  // Black Friday offer pages: bf_deal + bf_page for the discount Function (assets/bf-deal.js).
                }, window.omBfDeal ? window.omBfDeal.attrs(cartBefore) : {})
              })
            }).then(function () { return added; });
          })
          .then(function (added) {
            /* add_to_cart tracking: Elevar's automatic cart event is the ONE event (a manual push here double-counted, red team #7); list attribution rides the bundle_src cart attribute. */
            document.dispatchEvent(new CustomEvent('pdp:added', { detail: added }));
            openDrawer();
            addBtn.removeAttribute('aria-disabled');
          })
          .catch(function (err) {
            showError(err && err.userMessage ? err.userMessage : 'Sorry, this could not be added to your cart. Please try again.');
            addBtn.removeAttribute('aria-disabled');
          });
      });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('.lego-L46-v6').forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
/* L10 V5's one script: the `open` attribute is owned here, by WIDTH. syncOpen()
   opens every item from 750 and closes them below, called once at wiring time
   AND on the media query's own change (a listener that only fires on change
   leaves the page wrong at load, the D-054 bug). From 750 a keyboard toggle is
   re-asserted open, because the summary there is inert. Idempotent per section
   root and re-wired on shopify:section:load, per the theme's hard rules. */
(function () {
  var wide = window.matchMedia('(min-width: 750px)');
  function wire(root) {
    if (!root || root.dataset.l10Bound === '1') return;
    root.dataset.l10Bound = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('.l10-item'));
    function syncOpen() {
      var open = wide.matches;
      items.forEach(function (d) { d.open = open; });
    }
    if (wide.addEventListener) wide.addEventListener('change', syncOpen);
    else if (wide.addListener) wide.addListener(syncOpen);   /* older Safari */
    items.forEach(function (d) {
      d.addEventListener('toggle', function () { if (wide.matches && !d.open) d.open = true; });
    });
    syncOpen();
  }
  function init(scope) { (scope || document).querySelectorAll('.lego-L10-v5').forEach(wire); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  // wi-2026-launch-pdp-drawer-fix: same drawer-open contract as the buy box
  // (sections/pdp-buy-box.liquid) and the doors (assets/door-body.js) — publish
  // the theme's cartUpdate pub/sub, falling back to calling <cart-drawer>
  // directly when pub/sub isn't on the page.
  function openDrawer() {
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-sticky-atc' });
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.reload === 'function') drawer.reload().then(function () { drawer.open(); });
  }

  function wire(root) {
    if (!root || root.dataset.wired === '1') return;
    var box = document.querySelector('.lego-L46-v6');
    if (!box) return;                                  // no buy box on this template
    root.dataset.wired = '1';
    var html = document.documentElement;
    var bar = root.querySelector('.bar'), panel = root.querySelector('.panel'),
        scrim = root.querySelector('.scrim'), opener = root.querySelector('.open'),
        closer = root.querySelector('.close'), cta = root.querySelector('[data-atc="pdp_sticky"]');
    var desk = window.matchMedia('(min-width: 990px)');
    var q = function (s) { return root.querySelectorAll(s); };
    var mySize = function () { return root.querySelector('input[name^="l12v4-size-"]:checked'); };
    var myPlan = function () { var r = root.querySelector('input[name^="l12v4-plan-"]:checked'); return r ? r.value : 'sub'; };
    var boxSub = function () { return box.querySelector('[id^="l46-sub-"]'); };
    var boxSubOpt = function () { return box.querySelector('[data-lp-module="pdp-subscribe-toggle"]'); };

    /* B2B guard (wi-2026-0939). Shopify refuses a selling plan on a B2B order
       ("Only one-time purchase is available for B2B orders"). window.__omIsB2B
       (layout/theme.liquid, from customer.b2b?) is true only for a company
       buyer; for them the bar offers One-time only and never sends a plan.
       Client-side, so a normal shopper's server HTML is unchanged. The buy box
       applies the same guard, and this bar mirrors it (data-selling-plan). */
    var B2B = window.__omIsB2B === true;
    if (B2B) {
      var subIn = root.querySelector('input[name^="l12v4-plan-"][value="sub"]');
      var onceIn = root.querySelector('input[name^="l12v4-plan-"][value="once"]');
      if (subIn) { subIn.checked = false; subIn.disabled = true; }
      if (onceIn) onceIn.checked = true;
    }

    /* the add error line: script-created (first paint unchanged), inserted
       before any add so role=alert text written into it is announced */
    var errLine = null;
    if (cta) {
      errLine = document.createElement('p');
      errLine.className = 'atc-error om-small';
      errLine.setAttribute('role', 'alert');
      errLine.setAttribute('data-lp', 'atc_error');
      cta.insertAdjacentElement('afterend', errLine);
    }
    var GENERIC = 'Sorry, this could not be added to your cart. Please try again.';
    function showError(msg) { if (errLine) errLine.textContent = msg || ''; }

    /* every figure is read back from the buy box, after the buy box has re-priced */
    /* The Subscribe row keeps its price when One-time is chosen, which the buy box does not show:
       read once from Shopify's own product JSON after load (the rail: script only, D-053), the
       same best allocation the buy box picks. */
    var SUB = {};
    var cfgNode0 = box.querySelector('[data-pdp-pricing]');
    var cfg0 = null; try { cfg0 = JSON.parse(cfgNode0.textContent); } catch (e) {}
    function fmt(cents, sample) {
      var m = String(sample || '').match(/^([^\d]*)([\d.,]+)([^\d]*)$/);
      var body = (cents / 100).toFixed(2);
      if (!m) return body;
      if (m[2].indexOf(',') > -1 && m[2].indexOf('.') === -1) body = body.replace('.', ',');
      return m[1] + body + m[3];
    }
    if (cfg0 && cfg0.handle) fetch('/products/' + cfg0.handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.variants) return;
        d.variants.forEach(function (dv) {
          var a = dv.selling_plan_allocations || []; if (!a.length) return;
          var best = a[0]; a.forEach(function (x) { if (x.price < best.price) best = x; });
          var sample = ''; (cfg0.variants || []).forEach(function (cv) { if (cv.id === dv.id) sample = cv.priceFormatted; });
          SUB[dv.id] = fmt(best.price, sample);
        });
        paint();
      }).catch(function () {});
    function paint() {
      var subSlot = box.querySelector('[data-sub-price-slot]');
      var s0 = mySize();
      var id0 = s0 ? s0.value : (cfg0 && cfg0.variants && cfg0.variants[0] ? cfg0.variants[0].id : '');
      var subPrice = SUB[id0] || (subSlot && !subSlot.hidden && subSlot.firstElementChild ? subSlot.firstElementChild.textContent : '');
      var once = box.querySelector('[data-onetime-price]');
      var ship = box.querySelector('[data-onetime-detail]');
      var subAvail = !!(boxSubOpt() && boxSubOpt().dataset.sellingPlan);
      var subRow = root.querySelector('[data-l12-subopt]');
      if (subRow) subRow.hidden = B2B || (!subAvail && !!(once && once.textContent));
      q('[data-l12-sub]').forEach(function (n) { n.textContent = subPrice; });
      q('[data-l12-once]').forEach(function (n) { n.textContent = once ? once.textContent : ''; });
      q('[data-l12-ship]').forEach(function (n) { n.textContent = ship ? ship.textContent : ''; });
      var s = mySize();
      q('[data-l12-size]').forEach(function (n) { n.textContent = s ? s.dataset.sizeLabel : ''; });
      var sub = !B2B && myPlan() === 'sub' && subAvail;
      q('[data-l12-plan]').forEach(function (n) { n.textContent = sub ? root.dataset.subLabel : root.dataset.onceLabel; });
      q('[data-l12-price]').forEach(function (n) { n.textContent = sub ? subPrice : (once ? once.textContent : ''); });
      /* wi-2026-1199 (Nate pin 2026-09-30): a size with custom.ships_on also says so
         on the bar ("Ships Oct 12"), read from the buy box's own chip tag for the
         selected size. The node is created only when a tag exists, so products
         without ships_on keep identical markup. */
      var shipTag = null;
      if (id0) { var bIn = box.querySelector('input[name^="l46-size-"][value="' + id0 + '"]'); if (bIn && bIn.closest('label')) shipTag = bIn.closest('label').querySelector('.ship-tag'); }
      var l1 = root.querySelector('.bar .line1'), st = root.querySelector('[data-l12-shipson]');
      if (shipTag && l1) {
        if (!st) { st = document.createElement('span'); st.className = 'ship-tag om-caps'; st.setAttribute('data-l12-shipson', ''); l1.appendChild(st); }
        st.textContent = shipTag.textContent; st.hidden = false;
      } else if (st) { st.hidden = true; }
      /* Bundle mode only (the node exists nowhere else): the dollar saving the buy box
         writes into its own [data-sub-saving-order], kept after the shopper flips to
         One-time (the buy box clears it then). Script-filled, so no figure is in first paint. */
      var saveNodes = q('[data-l12-subsave]');
      if (saveNodes.length) {
        var boxSave = box.querySelector('[data-sub-saving-order]');
        var saveText = boxSave ? boxSave.textContent.trim() : '';
        if (saveText) root.dataset.l12SubSave = saveText;
        saveNodes.forEach(function (n) { n.textContent = root.dataset.l12SubSave ? ' ' + root.dataset.l12SubSave + '.' : ''; });
      }
    }
    function fromBuyBox() {
      var s = box.querySelector('input[name^="l46-size-"]:checked');
      if (s) { var mine = root.querySelector('input[name^="l12v4-size-"][value="' + s.value + '"]'); if (mine) mine.checked = true; }
      var sub = boxSub();
      if (sub) { var p = root.querySelector('input[name^="l12v4-plan-"][value="' + (!B2B && sub.checked ? 'sub' : 'once') + '"]'); if (p) p.checked = true; }
      paint();
    }
    function toBuyBox() {
      var s = mySize();
      if (s) {
        var b = box.querySelector('input[name^="l46-size-"][value="' + s.value + '"]');
        if (b && !b.checked) { b.checked = true; b.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      var radios = box.querySelectorAll('input[name^="l46-purchase-"]');
      var sub = boxSub();
      if (sub && radios.length === 2) {
        var want = myPlan() === 'sub' ? sub : (radios[0] === sub ? radios[1] : radios[0]);
        if (!want.checked) { want.checked = true; want.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      paint();
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input[name^="l12v4-"]')) toBuyBox(); });
    box.addEventListener('change', function (e) { if (e.target.matches('input[name^="l46-size-"], input[name^="l46-purchase-"]')) fromBuyBox(); });
    if (window.MutationObserver) new MutationObserver(paint).observe(box, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'data-selling-plan'] });

    /* show once the buy box's Add to cart is ABOVE the viewport; hide at the review widget */
    var main = box.querySelector('[data-atc="pdp_main"]');
    var stop = document.querySelector('.lego-L09-v5');
    var header = document.querySelector('.shopify-section.section-header');
    var mainGone = false, atStop = false;
    function setShown() {
      var show = mainGone && !atStop;
      if (desk.matches) {
        root.style.setProperty('--l12-top', (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 'px');
        panel.hidden = !show; bar.hidden = true;
      } else { bar.hidden = !show; if (!show) closeSheet(true); }
      var h = show ? (desk.matches ? panel : bar).offsetHeight : 0;
      html.style.setProperty('--om-sticky-h', h + 'px');
      html.style.scrollPaddingBottom = (!desk.matches && show) ? h + 'px' : '';
      html.style.scrollPaddingTop = (desk.matches && show) ? (h + (header ? header.offsetHeight : 0)) + 'px' : '';
    }
    var ticking = false;
    function check() {
      ticking = false;
      /* BFCM offer page (wi-2026-1419 call 5): the bar is up from first paint on a PHONE only, not after the buy box
         scrolls away. Desktop keeps the normal rule (audit-step2 F2): the buy box is on screen, so the bar has no job yet. */
      mainGone = (document.body.classList.contains('bf-offer') && !desk.matches) || (!!main && main.getBoundingClientRect().bottom < 0);
      atStop = !!stop && stop.getBoundingClientRect().top < window.innerHeight * 0.6;
      setShown();
    }
    /* Page-level listeners go on one signal so a swapped-out bar can be fully retired (root.omTeardown, called by
       assets/lp-picker.js). Without it the old bar's scroll check keeps running and writes --om-sticky-h from detached nodes. */
    var life = window.AbortController ? new AbortController() : null;
    var bound = life ? { signal: life.signal } : {};
    root.omTeardown = function () { if (life) life.abort(); };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true, signal: bound.signal });
    window.addEventListener('resize', check, bound);
    if (desk.addEventListener) desk.addEventListener('change', function () { closeSheet(true); panel.hidden = true; check(); }, bound);

    /* the sheet (phone) */
    function openSheet() {
      fromBuyBox(); panel.hidden = false; scrim.hidden = false; html.classList.add('om-sheet-open');
      opener.setAttribute('aria-expanded', 'true'); panel.setAttribute('aria-modal', 'true'); closer.focus();
    }
    function closeSheet(quiet) {
      if (desk.matches || panel.hidden) return;
      panel.hidden = true; scrim.hidden = true; html.classList.remove('om-sheet-open');
      opener.setAttribute('aria-expanded', 'false'); panel.removeAttribute('aria-modal');
      if (!quiet) opener.focus();
    }
    opener.addEventListener('click', openSheet);
    closer.addEventListener('click', function () { closeSheet(); });
    scrim.addEventListener('click', function () { closeSheet(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); }, bound);
    var sw = root.querySelector('[data-lp="switch_format"]');
    if (sw) sw.addEventListener('click', function (e) {
      e.preventDefault(); closeSheet(true);
      var target = box.querySelector('[data-lp="format_switcher"]') || box;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    /* the add: the same two-call contract as the buy box, its own surface */
    if (cta) cta.addEventListener('click', function () {
      toBuyBox();
      var s = box.querySelector('input[name^="l46-size-"]:checked');
      var cfgNode = box.querySelector('[data-pdp-pricing]');
      var id = s ? Number(s.value) : null;
      if (!id && cfgNode) { try { id = JSON.parse(cfgNode.textContent).variants[0].id; } catch (e) {} }
      if (!id) return;
      var subOpt = boxSubOpt(), sub = boxSub();
      var onSub = !B2B && !!(sub && sub.checked && subOpt && subOpt.dataset.sellingPlan);
      var item = { id: id, quantity: 1 }, cartBefore = null;
      if (onSub) item.selling_plan = Number(subOpt.dataset.sellingPlan);
      var bundleId = subOpt ? (subOpt.dataset.bundleId || '') : '';
      cta.setAttribute('aria-disabled', 'true');
      showError('');
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          cartBefore = c;
          var ig = c && c.attributes && c.attributes.igTestGroups;
          if (ig) item.properties = { _igTestGroups: ig };
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        })
        .then(function (r) {
          if (r.ok) return r.json();
          /* /cart/add.js answers 422 with { message, description }: show Shopify's own words */
          return r.json().catch(function () { return {}; }).then(function (j) {
            var err = new Error('add failed'); err.userMessage = (j && (j.description || j.message)) || GENERIC; throw err;
          });
        })
        .then(function (added) {
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            /* Black Friday offer pages: bf_deal + bf_page for the discount Function (assets/bf-deal.js). */
            body: JSON.stringify({ attributes: Object.assign({ bundle_id: bundleId, bundle_src: 'pdp_sticky' }, window.omBfDeal ? window.omBfDeal.attrs(cartBefore) : {}) }) }).then(function () { return added; });
        })
        .then(function () {
          /* add_to_cart tracking: Elevar's automatic cart event is the ONE event (a manual push here double-counted, red team #7); list attribution rides the bundle_src cart attribute. */
          closeSheet(true);
          document.dispatchEvent(new CustomEvent('pdp:added', { detail: { surface: 'pdp_sticky' } }));
          openDrawer();
          cta.removeAttribute('aria-disabled');
        })
        .catch(function (err) {
          showError(err && err.userMessage ? err.userMessage : GENERIC);
          if (!desk.matches && panel.hidden) openSheet();   /* phone: the line lives in the sheet */
          cta.removeAttribute('aria-disabled');
        });
    });

    window.OM_L12 = { open: openSheet, close: closeSheet, show: function () { mainGone = true; atStop = false; setShown(); } };
    fromBuyBox();
    check();
  }
  function init(scope) { (scope || document).querySelectorAll('.lego-L12-v4').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-board"] && !Shopify.designMode) return;
  try {
    
/* The offer bar's accept path. The same two-call contract the rest of the
   upsell surfaces use: /cart/add.js cannot write cart attributes, so the
   bundle_id + bundle_src pair rides a SECOND /cart/update.js. bundle_src is
   `upsell_pdp`, which is already enumerated — no new vocabulary is invented. */
(function () {
  function wire(root) {
    if (!root || root.dataset.wired === '1') return;
    root.dataset.wired = '1';
    var card = root.querySelector('[data-lp-module="bundle-offer-pdp"][data-bundle-id]');
    var cta = root.querySelector('[data-atc="pdp_bundle_card"]');
    if (!card || !cta) return;

    cta.addEventListener('click', function () {
      var vid = card.dataset.bundleVariantId;
      if (!vid) return;
      var item = { id: Number(vid), quantity: 1 };
      cta.setAttribute('aria-disabled', 'true');
      // row 18b: the test groups live on the CART, so they are read before the add.
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var ig = c && c.attributes && c.attributes.igTestGroups;
          if (ig) item.properties = { _igTestGroups: ig };
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (added) {
          var bid = card.dataset.bundleId || '';
          if (!bid) { console.warn('routine-board: no derivable bundle_id; skipping attribution write', card.dataset.bundleProductId); return added; }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              attributes: { bundle_id: bid, bundle_src: 'upsell_pdp' }
            })
          }).then(function () { return added; });
        })
        .then(function () {
          /* No manual dl_add_to_cart: Elevar's cart listener emits one per /cart/add; a manual push doubled it (O9 red team #7). Attribution rides the bundle_id/bundle_src cart attributes above. */
          document.dispatchEvent(new CustomEvent('pdp:added', { detail: { bundle: card.dataset.bundleId } }));
          cta.removeAttribute('aria-disabled');
        })
        .catch(function () { cta.removeAttribute('aria-disabled'); });
    });
  }
  function init(scope) { (scope || document).querySelectorAll('.lego-L51-v7').forEach(wire); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["traceability"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   The traceability modal. The five behaviours the CONTRACT owes and no source
   file carries: a scrim that closes on its OWN click, a focus trap, Escape,
   focus returned to the trigger, and a scroll lock on <html>.

   IDEMPOTENT by a marker on the section root, and wired to the three theme
   editor events, so a re-render cannot double-bind, leave a dead document
   listener behind, or strand the page with overflow: hidden.
   ========================================================================== */
(function () {
  var SECTION = '[data-traceability-section]';
  var LOCK = 'traceability-modal-open';
  var FOCUSABLE =
    'a[href],area[href],button:not([disabled]),input:not([disabled]),' +
    'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function setup(section) {
    if (!section || section.__omTraceability) return; /* idempotent */

    var trigger = section.querySelector('[data-lp-module="traceability-modal"]');
    var scrim = section.querySelector('[data-traceability-scrim]');
    var dialog = scrim ? scrim.querySelector('[role="dialog"]') : null;
    var closeBtn = section.querySelector('[data-traceability-close]');
    if (!trigger || !scrim || !dialog) return;

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
      });
    }

    /* One capturing handler carries BOTH Escape and the trap, so the two can
       never disagree about whether the panel is open. */
    function onKeydown(e) {
      if (scrim.hidden) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        shut();
        return;
      }
      if (e.key !== 'Tab' && e.keyCode !== 9) return;

      var list = focusables();
      if (!list.length) {
        e.preventDefault();
        dialog.focus();
        return;
      }
      var first = list[0];
      var last = list[list.length - 1];
      var active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || active === dialog || !dialog.contains(active)) {
          e.preventDefault();
          last.focus();
        }
      } else if (active === last || !dialog.contains(active)) {
        e.preventDefault();
        first.focus();
      }
    }

    function open() {
      scrim.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add(LOCK);
      document.addEventListener('keydown', onKeydown, true);
      var list = focusables();
      if (list.length) {
        list[0].focus();
      } else {
        /* the panel is not focusable by default; make it programmatically
           focusable so the reader lands inside the record they just opened */
        if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
        dialog.focus();
      }
    }

    function shut() {
      scrim.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove(LOCK);
      document.removeEventListener('keydown', onKeydown, true);
      trigger.focus(); /* focus RETURNS to the trigger, every close path */
    }

    function onTriggerClick() {
      if (scrim.hidden) {
        open();
      } else {
        shut();
      }
    }

    /* Only a click on the scrim ITSELF closes. A click inside the panel bubbles
       to the scrim too, so target identity is the whole test. */
    function onScrimClick(e) {
      if (e.target === scrim) shut();
    }

    trigger.addEventListener('click', onTriggerClick);
    scrim.addEventListener('click', onScrimClick);
    if (closeBtn) closeBtn.addEventListener('click', shut);

    section.__omTraceability = {
      teardown: function () {
        document.removeEventListener('keydown', onKeydown, true);
        trigger.removeEventListener('click', onTriggerClick);
        scrim.removeEventListener('click', onScrimClick);
        if (closeBtn) closeBtn.removeEventListener('click', shut);
        document.documentElement.classList.remove(LOCK);
        section.__omTraceability = null;
      }
    };
  }

  function wire(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(SECTION)) setup(scope);
    var nodes = scope.querySelectorAll(SECTION);
    for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
  }

  function unwire(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll(SECTION);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__omTraceability) nodes[i].__omTraceability.teardown();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      wire(document);
    });
  } else {
    wire(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    wire(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    unwire(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    wire(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
